import { useEffect, useState } from 'react'
import Table from '../../global/components/table/Table'
import { Column, Row } from 'react-table'
import UserModalMain from '../user-modal/UserModalMain'
import retrieveData from '../../global/components/table/helpers/retrieveData'
import { handleColumnFilterUpdate } from '../../global/components/table/helpers/multiColumnFilters'
import BasicFilter from '../../global/components/table/helpers/BasicFilter'
import { IUser } from '../../../../app/entities/User'

interface IUsersTableProps {
  setRefetchIndex: Function
  refetchIndex: number
}

function UsersTable(props: IUsersTableProps) {
  const { refetchIndex } = props
  const [userModalOpen, setUserModalOpen] = useState(false)
  const [userEmail, setUserEmail] = useState('')
  const [tableState, setTableState] = useState({
    data: [],
    isLoading: false,
    offSet: 0,
    pageSize: 100,
    count: 0,
  })
  const [columnFilters, setColumnFilters] = useState({})

  const endpoint = `${process.env.REACT_APP_ORIGIN}/users?`
  function onColumnFilterUpdate(filtersUpdate: object) {
    handleColumnFilterUpdate(filtersUpdate, columnFilters, setColumnFilters)
  }
  function retrieveTableData() {
    retrieveData(setTableState, {
      endpoint,
      pageSize: tableState.pageSize,
      offSet: tableState.offSet,
      columnFilters,
    })
  }
  useEffect(() => {
    retrieveTableData()
  }, [refetchIndex, tableState.pageSize, tableState.offSet])

  const columns: Column<IUser>[] = [
    {
      Header: 'Name',
      accessor: 'name',
      Filter: BasicFilter({
        onChange: (val: string) => onColumnFilterUpdate({ name: val }),
        onEnter: retrieveTableData,
      }),
    },
    {
      Header: 'Email',
      accessor: 'email',
      Filter: BasicFilter({
        onChange: (val: string) => onColumnFilterUpdate({ email: val }),
        onEnter: retrieveTableData,
      }),
    },
    {
      Header: 'Role',
      accessor: (data: any) => {
        const { role } = data
        if (!role) return ''

        return role.name
      },
      Filter: BasicFilter({
        onChange: (val: string) => onColumnFilterUpdate({ role: val }),
        onEnter: retrieveTableData,
      }),
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <UserModalMain
        isOpen={userModalOpen}
        email={userEmail}
        setRefetchIndex={props.setRefetchIndex}
        refetchIndex={props.refetchIndex}
        handleClosed={() => {
          setUserEmail('')
          setUserModalOpen(false)
        }}
      />
      <Table
        columns={columns}
        data={tableState.data ?? []}
        onRowClick={(row: Row) => {
          const { original } = row as any
          setUserEmail(original.email)
          setUserModalOpen(true)
        }}
        isLoading={tableState.isLoading}
        isPaginated
        pagination={{ setTableState, tableState }}
        isTableTopperPresent={false}
      />
    </div>
  )
}

export default UsersTable
